import React from 'react';

export default function Row({ size, children }) {

    let rowSize = size ? `row-${size}` : 'row'

    return (
        <div className={`${rowSize} w-row`}>
            {children}
        </div>
    );
}
